import React, { useEffect, useMemo, useState } from "react";
import { Button, Checkbox, message, Space, Table, Tooltip } from "antd";
import { lib } from "../index";
function SelectEnableTooltip({ children, selectEnable, ...rest }) {
    return (
        <>
            {selectEnable ? (
                <>{children}</>
            ) : (
                <Tooltip {...rest} title={"您不具备此权限无法编辑，请联系管理员"}>
                    {children}
                </Tooltip>
            )}
        </>
    );
}
export function WrapCheckbox({ isDetail, children, ...rest }) {
    return !isDetail ? (
        <Checkbox children {...rest}>
            {children}
        </Checkbox>
    ) : (
        <>{children}</>
    );
}
const TableComponent = () => {
    let systemCode = lib.config.systemCode;
    let roleId = lib.getParam("roleId");
    let isDetail = lib.getParam("isDetail") === "true";
    let systemTarget = lib.config.webToken === "admin" ? "/ucenter-admin" : "/ucenter-customer";
    const [menuData, setMenuData] = useState([]);
    const [checkSet, setCheckSet] = useState(new Set());
    const [indeterminateSet, setIndeterminateSet] = useState(new Set());
    const [depth, setDepth] = useState(0);
    //目前yw菜单动态配置层级最大支持3级
    const keyPool = ["firstLevel", "secondLevel", "thirdLevel"];
    useEffect(() => {
        /**
         * 初始化 checkSet 和 indeterminateSet
         * 根据 baseData 中的 auth 值进行初始化
         * auth 为 1 的节点将被选中，0 的不选中
         * 如果部分子节点被选中，则父节点设置为半选状态
         */

        // // 设置菜单数据
        lib.request({
            url: `${systemTarget}/role/permission/menuTree`,
            data: { systemCode, roleId },
            needMask: true,
            success: rest => {
                // 初始化选中状态
                const depth = getDepthAndMakeRowSpan(rest);
                setDepth(depth);
                initializeSelection(rest);
                setMenuData(rest);
            },
        });
    }, []);

    /**
     * 计算菜单树的最大深度，并为每个节点设置rowSpan属性
     * @param {Object} list - 菜单树数据
     * @returns {number} 菜单树的最大深度
     */
    function getDepthAndMakeRowSpan(list) {
        let maxDepth = 1;

        /**
         * 递归计算每个节点的rowSpan值
         * @param {Object} item - 当前节点
         * @param {number} level - 当前层级
         * @returns {number} 当前节点的rowSpan值
         */
        function getNum(item, level = 0) {
            maxDepth = Math.max(maxDepth, level);
            item.rowSpan = 0;
            if (item.list && item.list.length > 0 && item.list[0].id) {
                item.list.map(child => {
                    if (!isDetail || (isDetail && child.auth === 1)) item.rowSpan += getNum(child, level + 1);
                });
            } else {
                item.rowSpan = 1;
            }
            return item.rowSpan;
        }

        getNum({ list });
        return maxDepth;
    }

    const initializeSelection = nodes => {
        const initialCheckSet = new Set();
        const initialIndeterminateSet = new Set();

        /**
         * 递归遍历节点，设置 checkSet 和 indeterminateSet
         * @param {Object} node - 当前节点
         * @returns {boolean} 返回当前节点及其子节点是否全部选中
         */
        const traverse = node => {
            let allChildrenChecked = true;
            let someChildrenChecked = false;
            // 如果有子节点，递归遍历
            if (node.list && node.list.length > 0) {
                node.list.forEach(child => {
                    const childAllChecked = traverse(child);
                    if (allChildrenChecked && !childAllChecked) {
                        someChildrenChecked = true;
                    }
                    if (!childAllChecked) {
                        allChildrenChecked = false;
                    }
                    if (checkSet.has(child.id) || initialIndeterminateSet.has(child.id)) {
                        someChildrenChecked = true;
                    }
                });
            }

            // 如果有按钮，检查按钮的选中状态
            if (node.buttons && node.buttons.length > 0) {
                node.buttons.forEach(button => {
                    if (button.auth === 1) {
                        initialCheckSet.add(button.id);
                    }
                });
                const allButtonsChecked = node.buttons.every(button => button.auth === 1);
                const someButtonsChecked = node.buttons.some(
                    button => button.auth === 0,
                ); /*&& node.buttons.every(button => button.auth !== 0);*/
                if (allButtonsChecked) {
                    // 所有按钮都被选中
                    allChildrenChecked = true;
                } else if (someButtonsChecked) {
                    // 部分按钮被选中
                    someChildrenChecked = true;
                }
            }

            // 根据 auth 设置当前节点的选中状态
            if (node.auth === 1) {
                initialCheckSet.add(node.id);
            }
            // 根据子节点的选中状态设置父节点的半选状态
            if ((someChildrenChecked && node.auth === 1) || (!allChildrenChecked && node.auth === 1)) {
                initialIndeterminateSet.add(node.id);
            } else {
                initialIndeterminateSet.delete(node.id);
            }

            // 返回当前节点及其子节点是否全部选中
            return allChildrenChecked && node.auth === 1;
        };

        // 遍历所有一级菜单
        nodes.forEach(item => {
            traverse(item);
        });

        // 更新状态
        setCheckSet(initialCheckSet);
        setIndeterminateSet(initialIndeterminateSet);
    };
    /**
     * 将树形菜单数据转换为表格所需的扁平化数据结构
     * @returns {Array} 扁平化后的菜单数据数组
     */
    const dataSource = useMemo(() => {
        let keyIndex = 0;
        let initMenu = [];

        /**
         * 将树形数据扁平化为表格数据
         * @param {Array} menu - 当前层级的菜单数据
         * @param {Object} initObj - 初始化对象
         */
        const flapMenu = (menu, initObj) => {
            return menu.forEach((item, index) => {
                // 找到所有子菜单
                const children = item.list || [];
                let clone = lib.clone(initObj);
                let key = keyPool[keyIndex];
                clone[key] = { ...item, levelDepth: index };
                // 递归处理子菜单
                if (children.length > 0) {
                    keyIndex++;
                    flapMenu(children, clone);
                    keyIndex--;
                } else {
                    let lastMenu = initMenu[initMenu.length - 1];
                    for (let i = keyIndex - 1; i >= 0; i--) {
                        let lastDepthKey = keyPool[i];
                        const lastDepthValue = clone[lastDepthKey];
                        if (lastDepthValue.rowSpan > 1) {
                            let lastMenuItem =
                                lastMenu && lastMenu.hasOwnProperty(lastDepthKey) && lastMenu[lastDepthKey];
                            if (
                                lastMenuItem &&
                                lastDepthValue.levelDepth === lastMenuItem?.levelDepth &&
                                lastDepthValue.title === lastMenuItem.title
                            ) {
                                lastDepthValue.rowSpan = 0;
                            }
                        }
                    }
                    clone.buttons = !isDetail ? item.buttons : item.buttons.filter(item => item.auth === 1);
                    clone.uuid = clone[key].id;
                    if ((isDetail && item.auth === 1) || !isDetail) initMenu.push(clone);
                }
            }, []);
        };
        if (menuData.length > 0) {
            flapMenu(menuData, {});
        }
        // console.log("initMenu", initMenu);
        return initMenu;
    }, [menuData]);

    /**
     * 更新节点及其所有子节点的选中状态
     * @param {Object} item - 当前节点
     * @param {boolean} checked - 是否选中
     * @param {Set} newCheckSet - 选中状态集合
     * @param {Set} newIndeterminateSet - 半选状态集合
     */
    const updateCheckStatus = (item, checked, newCheckSet, newIndeterminateSet) => {
        let innerChecked = checked;
        // 更新当前节点状态
        if (newIndeterminateSet.has(item.id)) {
            innerChecked = true;
        }
        if (item.selectEnable) {
            if (innerChecked) {
                newCheckSet.add(item.id);
                newIndeterminateSet.delete(item.id);
            } else {
                newCheckSet.delete(item.id);
                newIndeterminateSet.delete(item.id);
            }
        }

        // 递归更新子菜单状态
        if (item.list && item.list.length > 0) {
            item.list.forEach(child => {
                updateCheckStatus(child, innerChecked, newCheckSet, newIndeterminateSet);
            });
        }

        // 更新按钮状态
        if (item.buttons && item.buttons.length > 0) {
            item.buttons.forEach(button => {
                updateCheckStatus(button, innerChecked, newCheckSet, newIndeterminateSet);
            });
        }
    };

    /**
     * 处理复选框选中状态变化
     * @param {string} level - 当前操作的层级（'firstLevel'|'secondLevel'|'thirdLevel'|'buttons'）
     * @param {Object} record - 当前行记录
     * @param {boolean} checked - 是否选中
     * @param {Object} button - 按钮对象（仅在处理按钮时传入）
     */
    const handleCheckboxChange = (level, record, checked, button) => {
        const newCheckSet = new Set(checkSet);
        const newIndeterminateSet = new Set(indeterminateSet);
        if (level === "buttons") {
            // 处理按钮级别的选中变化
            if (checked) {
                newCheckSet.add(button.id);
                newIndeterminateSet.delete(button.id);
            } else {
                newCheckSet.delete(button.id);
                newIndeterminateSet.delete(button.id);
            }

            // 确定按钮所属的父级层级（可能是第三层或第二层）
            let parentLevel = record.thirdLevel ? "thirdLevel" : record.secondLevel ? "secondLevel" : "firstLevel";
            let parent = record[parentLevel];
            // 更新父级菜单的状态
            if (parent) {
                const allButtonsChecked = !parent.buttons || parent.buttons.every(btn => newCheckSet.has(btn.id));
                const someButtonsChecked = parent.buttons && !allButtonsChecked;
                // 根据按钮选中情况更新父级状态
                if (allButtonsChecked) {
                    newCheckSet.add(parent.id);
                    newIndeterminateSet.delete(parent.id);
                } else if (someButtonsChecked) {
                    newCheckSet.add(parent.id);
                    newIndeterminateSet.add(parent.id);
                } else {
                    if (newCheckSet.has(parent.id)) {
                        newIndeterminateSet.add(parent.id);
                    }
                }
            }

            // 更新更高层级的菜单状态
            updateParentStatus(record, newCheckSet, newIndeterminateSet);
        } else {
            // 处理菜单级别的选中变化
            updateCheckStatus(record[level], checked, newCheckSet, newIndeterminateSet);
            // 从当前层级开始更新父级状态
            updateParentStatus(record, newCheckSet, newIndeterminateSet);
        }

        // 更新状态
        setCheckSet(newCheckSet);
        setIndeterminateSet(newIndeterminateSet);
    };

    /**
     * 根据子节点状态更新父节点的选中和半选状态
     * @param {Object} record - 当前行记录
     * @param {Set} newCheckSet - 选中状态集合
     * @param {Set} newIndeterminateSet - 半选状态集合
     * @param {string} currentLevel - 当前操作的层级
     */
    /**
     * 根据子节点状态更新父节点的选中和半选状态
     * @param {Object} record - 当前行记录
     * @param {Set} newCheckSet - 选中状态集合
     * @param {Set} newIndeterminateSet - 半选状态集合
     */
    const updateParentStatus = (record, newCheckSet, newIndeterminateSet) => {
        const levels = ["thirdLevel", "secondLevel", "firstLevel"];
        for (let i = 0; i < levels.length - 1; i++) {
            const currentLevel = levels[i];
            const parentLevel = levels[i + 1];
            if (record[currentLevel] && record[parentLevel]) {
                const parent = record[parentLevel];

                // 检查所有子节点是否全部选中（包括子菜单和按钮）
                let allChildrenButtonChecked =
                    !parent.buttons || parent.buttons.every(button => newCheckSet.has(button.id));
                const allChildrenChecked =
                    parent.list.every(child => newCheckSet.has(child.id) && !newIndeterminateSet.has(child.id)) &&
                    allChildrenButtonChecked;
                // 检查是否存在部分选中的子节点（包括子菜单和按钮）
                let someChildrenButtonChecked = parent.buttons && !allChildrenButtonChecked;
                const someChildrenChecked =
                    parent.list.some(child => newCheckSet.has(child.id) || newIndeterminateSet.has(child.id)) ||
                    someChildrenButtonChecked;

                //console.log("allChildrenButtonChecked", parent.title, allChildrenChecked, someChildrenButtonChecked);
                // 更新父节点状态
                if (allChildrenChecked) {
                    newCheckSet.add(parent.id);
                    newIndeterminateSet.delete(parent.id);
                } else if (someChildrenChecked) {
                    newCheckSet.add(parent.id);
                    newIndeterminateSet.add(parent.id);
                } else {
                    newCheckSet.delete(parent.id);
                    newIndeterminateSet.delete(parent.id);
                }
            }
        }
    };
    const depthColumns = useMemo(() => {
        let columns = [];
        if (depth > 0) {
            columns.push({
                title: "一级菜单",
                dataIndex: "firstLevel",
                render: (text, record) => (
                    <SelectEnableTooltip selectEnable={record.firstLevel.selectEnable}>
                        <WrapCheckbox
                            isDetail={isDetail}
                            disabled={!record.firstLevel.selectEnable}
                            checked={checkSet.has(record.firstLevel.id)}
                            indeterminate={indeterminateSet.has(record.firstLevel.id)}
                            onChange={e => handleCheckboxChange("firstLevel", record, e.target.checked)}>
                            {text.title}
                        </WrapCheckbox>
                    </SelectEnableTooltip>
                ),
                onCell: record => ({ rowSpan: record.firstLevel.rowSpan }),
            });
        }
        if (depth > 1) {
            columns.push({
                title: "二级菜单",
                dataIndex: "secondLevel",
                render: (text, record) =>
                    text && (
                        <SelectEnableTooltip selectEnable={record.secondLevel.selectEnable}>
                            <WrapCheckbox
                                isDetail={isDetail}
                                disabled={!record.secondLevel.selectEnable}
                                checked={checkSet.has(record.secondLevel.id)}
                                indeterminate={indeterminateSet.has(record.secondLevel.id)}
                                onChange={e => handleCheckboxChange("secondLevel", record, e.target.checked)}>
                                {text.title}
                            </WrapCheckbox>
                        </SelectEnableTooltip>
                    ),
                onCell: record => ({ rowSpan: record?.secondLevel?.rowSpan }),
            });
        }
        if (depth > 2) {
            columns.push({
                title: "三级菜单",
                dataIndex: "thirdLevel",
                render: (text, record) =>
                    text && (
                        <SelectEnableTooltip selectEnable={record.thirdLevel.selectEnable}>
                            <WrapCheckbox
                                isDetail={isDetail}
                                disabled={!record.thirdLevel.selectEnable}
                                checked={checkSet.has(record.thirdLevel.id)}
                                indeterminate={indeterminateSet.has(record.thirdLevel.id)}
                                onChange={e => handleCheckboxChange("thirdLevel", record, e.target.checked)}>
                                {text.title}
                            </WrapCheckbox>
                        </SelectEnableTooltip>
                    ),
            });
        }
        columns.push({
            title: "按钮",
            dataIndex: "buttons",
            render: (buttons, record) => (
                <Space wrap>
                    {buttons &&
                        buttons.length > 0 &&
                        buttons.map(button => (
                            <SelectEnableTooltip selectEnable={button.selectEnable}>
                                <WrapCheckbox
                                    isDetail={isDetail}
                                    disabled={!button.selectEnable}
                                    key={button.id}
                                    checked={checkSet.has(button.id)}
                                    indeterminate={indeterminateSet.has(button.id)}
                                    onChange={e => {
                                        handleCheckboxChange("buttons", record, e.target.checked, button);
                                    }}>
                                    {button.title}
                                </WrapCheckbox>
                            </SelectEnableTooltip>
                        ))}
                </Space>
            ),
        });
        return columns;
    }, [depth, checkSet, indeterminateSet]);

    console.log("Check Set:", Array.from(checkSet));
    console.log("Indeterminate Set:", Array.from(indeterminateSet));
    return (
        <>
            <Table dataSource={dataSource} columns={depthColumns} pagination={false} rowKey={"uuid"} />
            {!isDetail && (
                <div className="ft">
                    <Button
                        type="primary"
                        style={{ width: "120px" }}
                        onClick={() => {
                            lib.request({
                                url: `${systemTarget}/role/permission/update`,
                                data: {
                                    roleId,
                                    permissionId: [...checkSet],
                                },
                                needMask: true,
                                success: () => message.success("操作成功"),
                            });
                        }}>
                        保存
                    </Button>
                </div>
            )}
        </>
    );
};

export default TableComponent;
